/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Presence_S1Inputs */

const en_tut_presence_s1 = /** @type {(inputs: Tut_Presence_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Click the avatar stack in the top bar to open **Tim sekarang**. People are grouped into **Tersedia**, **Sibuk**, **Cuti / tidak di tempat**, and **Offline**, with their role, local time, and the issue they are working on.`)
};

const id_tut_presence_s1 = /** @type {(inputs: Tut_Presence_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klik tumpukan avatar di bar atas untuk membuka **Tim sekarang**. Orang dikelompokkan menjadi **Tersedia**, **Sibuk**, **Cuti / tidak di tempat**, dan **Offline**, lengkap dengan jabatan, jam setempat, dan issue yang sedang dikerjakan.`)
};

/**
* | output |
* | --- |
* | "Click the avatar stack in the top bar to open **Tim sekarang**. People are grouped into **Tersedia**, **Sibuk**, **Cuti / tidak di tempat**, and **Offline**,..." |
*
* @param {Tut_Presence_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_presence_s1 = /** @type {((inputs?: Tut_Presence_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Presence_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_presence_s1(inputs)
	return en_tut_presence_s1(inputs)
});